module.exports = __webpack_public_path__ + "media/Response5.afd8cc04.wav";